// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeCardApi = class EdgeCardApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param IActivateCardRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async cardV1ActivateCard(IActivateCardRequestModel, x_program_id) {
        const _url_ = '/edge/card/v1/ActivateCard';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IActivateCardRequestModel' is not null or undefined
        if (IActivateCardRequestModel === null || IActivateCardRequestModel === undefined) {
            throw new Error('Required parameter IActivateCardRequestModel was null or undefined when calling cardV1ActivateCard.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IActivateCardRequestModel, "IActivateCardRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CardV1ActivateCardDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param ICreateCardRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async cardV1CreateCard(ICreateCardRequestModel, x_program_id) {
        const _url_ = '/edge/card/v1/CreateCard';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ICreateCardRequestModel' is not null or undefined
        if (ICreateCardRequestModel === null || ICreateCardRequestModel === undefined) {
            throw new Error('Required parameter ICreateCardRequestModel was null or undefined when calling cardV1CreateCard.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ICreateCardRequestModel, "ICreateCardRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CardV1CreateCardDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param ICreatePrescriberRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async cardV1CreatePrescriber(ICreatePrescriberRequestModel, x_program_id) {
        const _url_ = '/edge/card/v1/CreatePrescriber';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ICreatePrescriberRequestModel' is not null or undefined
        if (ICreatePrescriberRequestModel === null || ICreatePrescriberRequestModel === undefined) {
            throw new Error('Required parameter ICreatePrescriberRequestModel was null or undefined when calling cardV1CreatePrescriber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ICreatePrescriberRequestModel, "ICreatePrescriberRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CardV1CreatePrescriberDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param IMedBenefitReplaceCardRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async medBenefitReplaceCard(IMedBenefitReplaceCardRequestModel, x_program_id) {
        const _url_ = '/edge/card/v1/MedBenefit/ReplaceCard';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IMedBenefitReplaceCardRequestModel' is not null or undefined
        if (IMedBenefitReplaceCardRequestModel === null || IMedBenefitReplaceCardRequestModel === undefined) {
            throw new Error('Required parameter IMedBenefitReplaceCardRequestModel was null or undefined when calling medBenefitReplaceCard.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IMedBenefitReplaceCardRequestModel, "IMedBenefitReplaceCardRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CardV1MedBenefitReplaceCardReplaceCardResponse");
        }
        return response;
    }
    /**
     *
     * @param ISendCardSmsRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async smsTextSend(ISendCardSmsRequestModel, x_program_id) {
        const _url_ = '/edge/card/v1/SmsText/Send';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ISendCardSmsRequestModel' is not null or undefined
        if (ISendCardSmsRequestModel === null || ISendCardSmsRequestModel === undefined) {
            throw new Error('Required parameter ISendCardSmsRequestModel was null or undefined when calling smsTextSend.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ISendCardSmsRequestModel, "ISendCardSmsRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CardV1SmsTextSendSendResponse");
        }
        return response;
    }
};
EdgeCardApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeCardApi);
export { EdgeCardApi };
//# sourceMappingURL=edgeCardApi.js.map